module.exports = __webpack_public_path__ + "img/homo_to_photo.4adb131e.png";